export const DARK_RED =  '#87002e';
export const LIGHT_RED = '#CE0000';
export const DARK_GRAY = '#161414';
export const GRAY = '#A0A0A0';
export const DARK_BLUE = '#0F4C81';
export const LIGHT_BLUE = '#00A8E8';
export const CYAN = '#00FFFF';
export const LIGHT_GRAY = "999999";